import { Fragment } from 'react';
import { clsx } from 'clsx';
import styles from './ImportStepper.module.css';

const IMPORT_STEPS = ['Upload file', 'Map columns', 'Resolve carriers', 'Preview & import'];

interface ImportStepperProps {
  /** 1-based current step. */
  current: number;
}

export function ImportStepper({ current }: ImportStepperProps) {
  return (
    <ol className={styles.stepper} aria-label="Import progress">
      {IMPORT_STEPS.map((label, i) => {
        const n = i + 1;
        const state = n === current ? 'active' : n < current ? 'done' : 'todo';
        return (
          <Fragment key={label}>
            {i > 0 && <span className={styles.line} aria-hidden />}
            <li
              className={clsx(
                styles.step,
                state === 'active' && styles.stepActive,
                state === 'done' && styles.stepDone,
              )}
              aria-current={state === 'active' ? 'step' : undefined}
            >
              <span className={styles.num}>{state === 'done' ? '✓' : n}</span>
              <span className={styles.label}>{label}</span>
            </li>
          </Fragment>
        );
      })}
    </ol>
  );
}
